<div id="lm-header">
    <app-admin-header></app-admin-header>
    <app-header></app-header>
</div>
<div>
    <iframe [src]="embedLocation" id="asset-content" scrolling="no"></iframe>
</div>
<app-footer></app-footer>
